import { environmentVars } from 'constants/services';
import { getAppServices } from 'providers/app-services';

export interface Payload {
  name: string;
  message: string;
  subject: string;
}

export const contactSupport = async (payload: Payload) => {
  const { authService } = getAppServices();
  const { accessToken } = authService.getCredentials();

  const response = await fetch(
    environmentVars.API_GATEWAY_CONTACT_US_ENDPOINT,
    {
      method: 'POST',
      mode: 'cors',
      cache: 'no-cache',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify({
        name: payload.name,
        message: payload.message,
        subject: payload.subject,
      }),
    }
  );

  return response?.status.toString() === '200' || false;
};
